module.exports = __webpack_public_path__ + "img/shoes.a98a0c0e.svg";